export default __webpack_public_path__ + "static/media/Agent-Network-Locations-Banner.c6a2e1a8.png";